import rankedList from '~/utils/ranked-list'

export const getCombinedSort = (data, sortFn) => data.sort((a, b) => rankedList(a, b) || sortFn(a, b) || 0)

export const getNumericSortList = (data) => data.sort((a, b) => (a.value < b.value ? -1 : 1))

const getRange = (from, to, data) => {
  return data.find(({ rangeFrom, rangeTo }) => rangeFrom === from && (rangeTo === to || (!rangeTo && !to)))
}

export const getRangeInputValues = (range, data) => {
  const { rangeFrom, rangeTo } = range
  const filteredRange = getRange(rangeFrom, rangeTo, data)

  const count = filteredRange ? filteredRange.count : 0
  const available = count > 0
  const value = JSON.stringify(range)

  return { available, value, count }
}
